import { Component, ViewEncapsulation, Input, Output, EventEmitter, Injector } from '@angular/core';

import { Translations } from './grid.translation';
import { Column } from './column';
import { Multilingual } from '../../models/multilingual';

import { PlatformService } from '../../services/platform/platform.service';

@Component({
    selector: 'grid2',
    template: `
    <div class="table-responsive">
        <div class="col-12" *ngIf="displayFilter">
            <input name="searchField" [(ngModel)]="searchField" [placeholder]="ui.search" class="form-control search-field d-inline-block my-2"
                type="text" (keydown)="handleKeyDown($event)">
            <a class="waves-effect waves-light align-middle" (click)="onSearch()">
                <i class="fa fa-search fa-lg"></i>
            </a>
        </div>
        <div class="card pt-0 mb-3 o-hid">
            <table class="table table-sm" (window:scroll)="onScroll($event)" [ngClass]="{'table-hover': cellLink}">
                <thead>
                    <tr>
                        <th *ngFor="let column of columns">{{ parentUi[column.title] || column.title }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of rows">
                        <td *ngFor="let column of columns" [ngClass]="{'cell-link': cellLink}">
                            <div *ngIf="column.type == 'text'" (click)="column.action(row)">{{ row[column.name] }}</div>
                            <div *ngIf="column.type == 'date'" (click)="column.action(row)">{{ row[column.name] | date }}</div>
                            <a *ngIf="column.type == 'button'" class="blue-text" (click)="column.action(row, column)">
                                <i class="fa {{column.icon}}"></i>
                            </a>
                            <a *ngIf="column.type == 'condition'" (click)="column.action(row)">
                                <span [innerHTML]="column.condition(row)"></span>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="loading" class="col-12 text-center">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
    </div>`,
    styles: [`
    td.cell-link {
        cursor: pointer;
    }
    .search-field {
      max-width: 200px;
    }
    @-moz-document url-prefix() {
      fieldset { display: table-cell; }
    }
    .card {
      margin-bottom: 1rem;
    }
    .grid-card-block {
      padding: 0px;
    }
    .card-modal {
      margin-bottom: 0px;
    }
    @media (max-width: 991px) { 
      .card {
          -webkit-border-radius: 0px;
          -moz-border-radius: 0px;
          -ms-border-radius: 0px;
          -o-border-radius: 0px;
          border-radius: 0px;
      }
      .card .card-header {
          -webkit-border-radius: 0px;
          -moz-border-radius: 0px;
          -ms-border-radius: 0px;
          -o-border-radius: 0px;
          border-radius: 0px;
      }
    }
    .form-header.grid-form-header {
      margin-bottom: 1rem;
      padding: 0.5rem;
    }
    .grid-search-input {
      display: inline-block;
      padding: 0;
      margin: 0;
    }
    .grid-small-device {
      padding: 0.5rem;
    }
    .grid-card-title {
      margin-top: 3px;
      margin-bottom: 2px;
      display: inline-table;
    }
    .navbar-btn {
      padding: .5rem 1rem;
      color: rgba(0, 0, 0, 0.54) !important;
    }
    .grid-card {
      padding-right: 0;
    }
    .grid-header {
      padding:.20rem;
      background-color: #FFF !important;
      width: 100%;
      display: block;
    }
    .grid-sm-row {
      margin: 15px 15px 0 0;
    }
    
    .grid-sm-col {
      padding: 0 0.5rem;
    }
    
    .table thead {
      background-color: #007bff !important;
    }
    
    .table thead th {
      color: white !important;
    }
    
    .grid-col-header {
      color: rgba(0, 0, 0, 0.54) !important;
      font-size: x-small;
      padding-right: 10px;
    }
    .grid-col-data {
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    @media (max-width: 575px) { 
      .grid-title {
          margin-top: 0.1rem;
          font-size: 1rem;
      }
    }
    .table {
      margin-bottom: 0px;
    }
    .pagination {
      margin: 0.5rem;
    }
    .page-item {
      display: inline-block;
    }
    .select-wrapper input.select-dropdown {
      margin: 0px;
    } 
    .grid-selector {
      max-width: 90px;
    }
    
    .profil {
      padding: 1rem 0px;
      text-align: center;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      -ms-border-radius: 3px;
      -o-border-radius: 3px;
      border-radius: 3px;
      border: 1px solid rgba(0,0,0,.2);
    }
    [type="radio"]:checked + label, [type="radio"]:not(:checked) + label, [type="checkbox"] + label {
      padding-left: 0px;
      margin-left: 3px;
    }
    /*.grid-checkbox {
      width: 35px;
    }*/
    .table a {
      margin-left: 0px;
    }
    
    .page-item.active .page-link {
      background-color: #007bff;
    } 
    
    .mdb-skin input[type=checkbox]:checked+label:before {
      border-right: 2px solid #00C851;
      border-bottom: 2px solid #00C851;
    }
    input[type="text"]::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: #007bff;
    }
    input[type="text"]::-moz-placeholder { /* Firefox 19+ */
      color: #007bff;
    }
    input[type="text"]:-ms-input-placeholder { /* IE 10+ */
      color: #007bff;
    }
    input[type="text"]:-moz-placeholder { /* Firefox 18- */
      color: #007bff;
    }`],
    encapsulation: ViewEncapsulation.None
})

export class Grid2Component extends Multilingual {

    protected platform: PlatformService;
    @Input() public parentUi: any = {};
    @Input() public columns: Array<Column> = [];
    @Input() public rows: Array<Object> = [];
    @Input() public loading: Boolean = false;
    @Input() public cellLink: Boolean = false;
    @Input() public displayFilter: Boolean = true;
    @Input() public limit: number = 30;
    public searchField: string;

    constructor(injector: Injector) {
        super(injector);
        this.platform = injector.get(PlatformService);
        this.setTranslations(Translations);
    }

    onScroll($event: any) {
    }
    
}